// extracted by mini-css-extract-plugin
export var hidden = "_o1-1";
export var visible = "_o1-0";